let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7yM1X")).then(() => parcelRequire('6AOzH'));